<template functional>
  <router-link
    :class="`learning-path-tile ${props.customClass || ''}`"
    :to="{ name: 'playlist', params: { id: props.path.id } }"
  >
    <div
      class="learning-path-tile__background"
      :style="
        `background-image: url(${props.backgroundImg}), linear-gradient(${props.gradient});`
      "
    >
      <div class="learning-path-tile__overlay"></div>
      <div class="learning-path-tile__details">
        <div class="learning-path-tile__title">{{ props.path.title }}</div>
        <div class="learning-path-tile__instructor">
          <div
            v-if="props.path.instructors && props.path.instructors.length !== 0"
            class="learning-path-tile__name-wrapper"
          >
            <p class="learning-path-tile__instructor-lead">Head Instructor</p>
            <p class="learning-path-tile__name">
              {{
                props.path.instructors[0].full_name ||
                  `${props.path.instructors[0].first_name} ${props.path.instructors[0].last_name}`
              }}
            </p>
          </div>
          <div
            v-if="props.categoryName && props.categoryName !== ''"
            class="learning-path-tile__branding"
          >
            {{ props.categoryName }}
          </div>
        </div>
      </div>
      <div class="learning-path-tile__extended-details">
        <div class="learning-path-tile__duration-wrapper">
          <p class="lead">duration</p>
          <p class="data">{{ props.duration }}</p>
        </div>
        <div class="learning-path-tile__difficulty-wrapper">
          <p class="lead">difficulty</p>
          <p class="data">
            <span class="learning-path-tile__difficulty-component">
              <component
                :is="props.components.DifficultyComponent"
                :difficulty="props.difficulty || null"
              ></component>
            </span>
          </p>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import DifficultyComponent from './DifficultyComponent.vue'

export default {
  name: 'LearningPathTile',
  props: {
    components: {
      type: Object,
      default() {
        return {
          DifficultyComponent,
        }
      },
    },
    path: {
      type: Object,
      required: true,
    },
    backgroundImg: {
      type: String,
      required: true,
    },
    gradient: {
      type: String,
      required: true,
    },
    duration: {
      type: String,
      required: true,
    },
    categoryName: {
      type: String,
      required: false,
    },
    difficulty: {
      type: Number,
      required: true,
    },
    customClass: {
      type: String,
      required: false,
    },
  },
}
</script>

<style lang="scss">
.learning-path-tile {
  height: 300px;
  min-height: 300px;
  min-width: 350px;
  text-align: left;
  background-color: var(--light-gray);
  color: var(--white);
  margin-bottom: 10px;
  text-decoration: none;
  &:hover {
    cursor: pointer;
    .learning-path-tile__overlay {
      opacity: 1;
    }
  }
  &__background {
    height: 225px;
    min-height: 225px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    background-color: var(--orange);
    z-index: 1;
  }
  &__overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    right: 0;
    top: 0;
    z-index: -1;
    opacity: 0;
    transition: 0.5s all ease;
  }
  &__details {
    width: 100%;
    padding: 30px 25px 15px 30px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
  }
  &__title {
    font-size: 1.2rem;
    font-weight: 700;
    width: 220px;
    color: var(--white);
  }
  &__instructor {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  &__instructor-lead {
    color: lightgray;
    text-transform: uppercase;
    margin: 0;
    font-size: 0.8rem;
    font-weight: 700;
  }
  &__name {
    color: var(--white);
    font-weight: 700;
    margin: 0;
  }
  &__branding {
    font-weight: 700;
    font-size: 0.8rem;
    text-transform: uppercase;
    justify-self: flex-end;
    margin: 0 0 0 auto;
  }
  &__extended-details {
    display: flex;
    margin: 10px 0 0 0;
    padding: 0 20px;
  }
  &__duration-wrapper {
    margin: 0 50px 0 0;
  }
  &__course-id {
    text-align: center;
    margin-top: 75px;
    color: var(--orange);
  }
  .lead {
    font-size: 0.9rem;
  }
}
</style>
